<template>
  <div>
    <v-row class="monitoring-cards__row row">
      <v-col class="col-lg-12">
          <v-row>
            <v-col class="col-lg-3">
              <MonitoringCard title="Community API status">
                <template v-slot:tooltip>Lucy Community API status</template>
                <v-row v-if="loadStatuses">
                  <v-alert shaped type="warning">Checking...</v-alert>
                </v-row>
                <v-row v-else-if="~loadStatuses&&statusCommunityAPI">
                  <v-alert shaped type="success">Online</v-alert>
                </v-row>
                <v-row v-else>
                  <v-alert shaped type="warning" color="red">Offline</v-alert>
                </v-row>
              </MonitoringCard>
            </v-col>
            <v-col class="col-lg-3">
              <MonitoringCard title="Projects API status">
                <template v-slot:tooltip>Lucy Projects API status</template>
                <v-row v-if="loadStatuses">
                  <v-alert shaped type="warning">Checking...</v-alert>
                </v-row>
                <v-row v-else-if="~loadStatuses&&statusProjectsAPI">
                  <v-alert shaped type="success">Online</v-alert>
                </v-row>
                <v-row v-else>
                  <v-alert shaped type="warning" color="red">Offline</v-alert>
                </v-row>
              </MonitoringCard>
            </v-col>
            <v-col class="col-lg-3">
              <MonitoringCard title="RDS status">
                <template v-slot:tooltip>Relational Database Service (users database) status</template>
                <v-row v-if="loadStatuses">
                  <v-alert shaped type="warning">Checking...</v-alert>
                </v-row>
                <v-row v-else-if="~loadStatuses&&statusRDS">
                  <v-alert shaped type="success">Online</v-alert>
                </v-row>
                <v-row v-else>
                  <v-alert shaped type="warning" color="red">Offline</v-alert>
                </v-row>
              </MonitoringCard>
            </v-col>
            <v-col class="col-lg-3">
              <MonitoringCard title="ElasticSearch status">
                <template v-slot:tooltip>ElasticSearch Service (tweets database) status</template>
                <v-row v-if="loadStatuses">
                  <v-alert shaped type="warning">Checking...</v-alert>
                </v-row>
                <v-row v-else-if="~loadStatuses&&statusES">
                    <v-alert shaped type="success">Online</v-alert>
                </v-row>
                <v-row v-else>
                  <v-alert shaped type="warning" color="red">Offline</v-alert>
                </v-row>
              </MonitoringCard>
            </v-col>
          </v-row>
      </v-col>
    </v-row>

    <v-row class="monitoring-cards__row row">
      <v-col class="col-lg-6">
        <MonitoringCard title="Panel pool size"
                     :subtitle="'Number of panel members (last ' + panelSizeTimelineDateRange + ' days)'"
                     :loading="loadPanelSizeTimeline">
            <Plotly :data="lplotlify(panelSizeTimeline, 'Panel size')" :layout="layoutPanelSizeTimeline"></Plotly>
            <template v-slot:tooltip>
                Number of members in the panel each day.
            </template>
        </MonitoringCard>
      </v-col>
      <v-col class="col-lg-6">
        <MonitoringCard title="Candidates pool size"
                     :subtitle="'Number of candidates pool members (last ' + candidatesSizeTimelineDateRange + ' days)'"
                     :loading="loadCandidatesSizeTimeline">
            <Plotly :data="lplotlify(candidatesSizeTimeline, 'Candidates size')" :layout="layoutCandidatesSizeTimeline"></Plotly>
            <template v-slot:tooltip>
                Number of members in candidates pool each day.
            </template>
        </MonitoringCard>
      </v-col>
    </v-row>
    <v-row class="monitoring-cards__row row">
      <v-col class="col-lg-6">
        <MonitoringCard title="Panel dynamics"
                     :subtitle="'Number of users added to and removed from the panel  (last ' + removedUsersTimelineDateRange + ' days)'"
                     :loading="loadAddedUsersTimeline&&loadRemovedUsersTimeline">
            <Plotly :data="merge([lplotlify(addedUsersTimeline, 'Added users'), lplotlify(removedUsersTimeline, 'Removed users')])"></Plotly>
            <template v-slot:tooltip>
                The number of new users added to and removed from the panel each day.
            </template>
        </MonitoringCard>
      </v-col>
      <v-col class="col-lg-6">
        <MonitoringCard title="Published tweets - panel"
                     :subtitle="'Number of tweets published by panel members (last ' + tweetsPanelTimelineDateRange + ' days)'"
                     :loading="loadTweetsPanelTimeline">
            <Plotly :data="lplotlify(tweetsPanelTimeline, 'Removed users')"></Plotly>
            <template v-slot:tooltip>
                Sum of tweets published by panel members each day.
            </template>
        </MonitoringCard>
      </v-col>
    </v-row>
    <v-row class="monitoring-cards__row row">
      <v-col class="col-lg-6">
        <MonitoringCard title="Panels users share"
                     :subtitle="'Users share between panel at time t and t+30 (last ' + panelShareTimelineDateRange + ' days)'"
                     :loading="loadPanelShareTimeline">
            <Plotly :data="lplotlify(panelShareTimeline, 'Removed users')"></Plotly>
            <template v-slot:tooltip>
                How many users who were in the panel 30 days ago (<i>t-30</i>) are still in the current (<i>t</i>) panel.
                The share of users between panel at time <i>t-30</i> and <i>t</i>.
            </template>
        </MonitoringCard>
      </v-col>
      <v-col class="col-lg-6">
        <MonitoringCard title="Panel activity"
                     :subtitle="'% of panel members who were active (last ' + panelActivityTimelineDateRange + ' days)'"
                     :loading="loadPanelActivityTimeline">
            <Plotly :data="lplotlify(panelActivityTimeline, 'Removed users')"></Plotly>
            <template v-slot:tooltip>
                The proportion of the panel that was active in the last 24 hours.
            </template>
        </MonitoringCard>
      </v-col>
    </v-row>
    <v-row class="monitoring-cards__row row">
      <v-col class="col-lg-6">
         <MonitoringCard title="Community size dynamic"
                        :subtitle="'% of panel members that follows specific account (last ' + communitySizeTimelineDateRange + ' days)'"
                        :loading="loadCommunitySizeTimeline">
             <Plotly :data="merge(dataCommunitySizeTimeline())"></Plotly>
             <template v-slot:tooltip>
                 % of panel members that follows specific account each day
             </template>
         </MonitoringCard>
      </v-col>
    </v-row>
  </div>
</template>

<script>
      import axios from 'axios'
      import {Plotly} from 'vue-plotly'
      import MonitoringService from "../../services/monitoring.service";
      import MonitoringCard from "./MonitoringCard";

      export default {
          components: {Plotly, MonitoringCard},
          name: "Charts",
          props: [],
          data: () => ({
              statusCommunityAPI: false,
              statusProjectsAPI: false,
              statusRDS: false,
              statusES: false,
              payload: {date: new Date(new Date().setDate(new Date().getDate()-1)).toISOString().slice(0, 10), range: 30},
              panelSizeTimeline: [],
              candidatesSizeTimeline: [],
              tweetsPanelTimeline: [],
              tweetsCandidatesTimeline: [],
              addedUsersTimeline: [],
              removedUsersTimeline: [],
              panelShareTimeline: [],
              panelActivityTimeline: [],
              communitySizeTimeline: [],
              panelSizeTimelineDateRange: 0,
              candidatesSizeTimelineDateRange: 0,
              tweetsPanelTimelineDateRange: 0,
              tweetsCandidatesTimeline: 0,
              addedUsersTimelineDateRange: 0,
              removedUsersTimelineDateRange: 0,
              panelShareTimelineDateRange: 0,
              panelActivityTimelineDateRange: 0,
              communitySizeTimelineDateRange: 0,
              loadStatuses: true,
              loadPanelSizeTimeline: true,
              loadCandidatesSizeTimeline: true,
              loadTweetsPanelTimeline: true,
              loadTweetsCandidatesTimeline: true,
              loadAddedUsersTimeline: true,
              loadRemovedUsersTimeline: true,
              loadPanelShareTimeline: true,
              loadPanelActivityTimeline: true,
              loadCommunitySizeTimeline: true,
              panelSizeTimelineRange: [],
              candidatesSizeTimelineRange: [],
              layoutPanelSizeTimeline: [],
              layoutCandidatesSizeTimeline: []
          }),
          computed: {
          },
          methods: {
            fetchPanelSizeTimeline() {
              var cs = new MonitoringService();
              cs.getPanelSizeTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.panelSizeTimeline = resp.data;
                    this.panelSizeTimelineDateRange = resp.data.length - 1;
                    this.loadPanelSizeTimeline = false;
                    this.panelSizeTimelineRange = [Math.min.apply(Math, resp.data.map(function(o) { return o.y; })), Math.max.apply(Math, resp.data.map(function(o) { return o.y; }))]
                    this.panelSizeTimelineRange[0] = this.panelSizeTimelineRange[0] - this.panelSizeTimelineRange[0] * 0.0001
                    this.panelSizeTimelineRange[1] = this.panelSizeTimelineRange[1] + this.panelSizeTimelineRange[1] * 0.0001
                    this.layoutPanelSizeTimeline = {
                      yaxis: {
                        tickformat: ',d',
                        autorange: false,
                        range: this.panelSizeTimelineRange
                      }
                    }
                  }
                  return resp;
              })
            },
            fetchCandidatesSizeTimeline() {
              var cs = new MonitoringService();
              cs.getCandidatesSizeTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.candidatesSizeTimeline = resp.data;
                    this.candidatesSizeTimelineDateRange = resp.data.length - 1;
                    this.loadCandidatesSizeTimeline = false;
                    this.candidatesSizeTimelineRange = [Math.min.apply(Math, resp.data.map(function(o) { return o.y; })), Math.max.apply(Math, resp.data.map(function(o) { return o.y; }))]
                    this.candidatesSizeTimelineRange[0] = this.candidatesSizeTimelineRange[0] - this.candidatesSizeTimelineRange[0] * 0.002
                    this.candidatesSizeTimelineRange[1] = this.candidatesSizeTimelineRange[1] + this.candidatesSizeTimelineRange[1] * 0.002
                    this.layoutCandidatesSizeTimeline = {
                      yaxis: {
                        tickformat: ',d',
                        autorange: false,
                        range: this.candidatesSizeTimelineRange
                      }
                    }
                  }
                  return resp;
              })
            },
            fetchPublishedTweetsPanelTimeline() {
              var cs = new MonitoringService();
              cs.getPublishedTweetsPanelTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.tweetsPanelTimeline = resp.data;
                    this.tweetsPanelTimelineDateRange = resp.data.length - 1;
                    this.loadTweetsPanelTimeline = false;
                  }
                  return resp;
              })
            },
            fetchPublishedTweetsCandidatesTimeline() {
              var cs = new MonitoringService();
              cs.getPublishedTweetsCandidatesTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.tweetsCandidatesTimeline = resp.data;
                    this.tweetsCandidatesTimelineDateRange = resp.data.length - 1;
                    this.loadTweetsCandidatesTimeline = false;
                  }
                  return resp;
              })
            },
            fetchAddedUsersTimeline() {
              var cs = new MonitoringService();
              cs.getAddedUsersTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.addedUsersTimeline = resp.data;
                    this.addedUsersTimelineDateRange = resp.data.length - 1;
                    this.loadAddedUsersTimeline = false;
                  }
                  return resp;
              })
            },
            fetchRemovedUsersTimeline() {
              var cs = new MonitoringService();
              cs.getRemovedUsersTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.removedUsersTimeline = resp.data;
                    this.removedUsersTimelineDateRange = resp.data.length - 1;
                    this.loadRemovedUsersTimeline = false;
                  }
                  return resp;
              })
            },
            fetchPanelShareTimeline() {
              var cs = new MonitoringService();
              cs.getPanelShareTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.panelShareTimeline = resp.data;
                    this.panelShareTimelineDateRange = resp.data.length - 1;
                    this.loadPanelShareTimeline = false;
                  }
                  return resp;
              })
            },
            fetchPanelActivityTimeline() {
              var cs = new MonitoringService();
              cs.getPanelActivityTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.panelActivityTimeline = resp.data;
                    this.panelActivityTimelineDateRange = resp.data.length - 1;
                    this.loadPanelActivityTimeline = false;
                  }
                  return resp;
              })
            },
            fetchCommunitySizeTimeline() {
              var cs = new MonitoringService();
              cs.getCommunitySizeTimeline(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.communitySizeTimeline = resp.data;
                    this.communitySizeTimelineDateRange = resp.data[0].data.length - 1;
                    this.loadCommunitySizeTimeline = false;
                  }
                  return resp;
              })
            },
            fetchStatuses() {
              var cs = new MonitoringService();
              cs.getStatuses(this.payload).then(resp => {
                  // Only 200 gives real data
                  if (resp.status == 200) {
                    this.statusCommunityAPI = resp.data.statusCommunityAPI;
                    this.statusProjectsAPI = resp.data.statusProjectsAPI;
                    this.statusRDS = resp.data.statusRDS;
                    this.statusES = resp.data.statusES;
                    this.loadStatuses = false;
                  }
                  return resp;
              })
            },
            _lPlotlify(d, name) {
                return {
                    x: _.map(d, e => e.x),
                    y: _.map(d, e => e.y),
                    type: "scatter",
                    name: name
                }
            },
            lplotlify(d, name) {
                return d ? [this._lPlotlify(d, name)] : []
            },
            replace(str) {
              return str.replace(/_/g, ' ');
            },
            merge(array) {
              var arrayLength = array.length;
              for (var i = 1; i < arrayLength; i++) {
                  Array.prototype.push.apply(array[0], array[i]);
              }
              return array[0]
            },
            dataCommunitySizeTimeline () {
              var arrayLength = this.communitySizeTimeline.length;
              var array = []
              for (var i = 0; i < arrayLength; i++) {
                array.push(this.lplotlify(this.communitySizeTimeline[i].data, this.replace(this.communitySizeTimeline[i].name)));
              }
              return array
            }
          },
          async mounted () {
            await this.fetchStatuses()
            await this.fetchPanelSizeTimeline()
            await this.fetchCandidatesSizeTimeline()
            await this.fetchPublishedTweetsPanelTimeline()
            await this.fetchPublishedTweetsCandidatesTimeline()
            await this.fetchAddedUsersTimeline()
            await this.fetchRemovedUsersTimeline()
            await this.fetchPanelShareTimeline()
            await this.fetchPanelActivityTimeline()
            await this.fetchCommunitySizeTimeline()
          }
      }
</script>
